import styled, {css} from 'styled-components';

import {ms} from '../../../../styles/normalizeSize';
import {getColor} from '../../../../styles/utils';
import {Text} from '../../../../uikit/Text';
import {View} from '../../../../uikit/View';

const errorStyle = css`
  padding: ${ms(20)};
  font-size: ${ms(13)};
  line-height: ${ms(18)};
  color: ${getColor('error')};
  text-align: center;
`;

export const Container = styled(View)`
  width: 100%;
  height: 100%;
  position: relative;
  background-color: ${getColor('background2')};
  display: flex;
  align-items: center;
  justify-content: center;

  & > div > div > div {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${getColor('background2')};

    ${errorStyle};
  }
`;

export const Error = styled(Text)`
  ${errorStyle};
`;
